import testPlanApi from "../api/testPlan";

const actions = {
  async resetHistoricalTestPlanStatus({ commit, state }, serviceAreaId: number) {
    const {
      data: { result },
    } = await testPlanApi.resetHistoricalTestPlanStatus(serviceAreaId);
    commit("setHistoricalTestPlanStatusResult", result);
  },
  async setHistoricalTestPlanStatus({ commit, state }, serviceAreaId: number) {
    const {
      data: { result },
    } = await testPlanApi.setHistoricalTestPlanStatus(serviceAreaId);
    commit("setHistoricalTestPlanStatusResult", result);
  },
};

const mutations = {
  setLoader(state, isLoading) {
    state.isLoading = isLoading;
  },
  setHistoricalTestPlanStatusResult(state, result) {
    state.historicalTestPlanStatusResult = result;
  },
};

const state = {
  isLoading: false,
  historicalTestPlanStatusResult: null,
};

const getters = {};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
